import apiClient from "./ApiClient";

export function createMenuJob(payload) {
  return apiClient.post("/menu-jobs", payload).then(res => res.data);
}

/**
 * Fetch all menu processing jobs for a restaurant
 * @param {number|string} restaurantId
 * @returns {Promise<Object[]>}
 */
export function fetchMenuJobsByRestaurant(restaurantId) {
  return apiClient
    .get(`/menu-jobs/restaurant/${restaurantId}`)
    .then((res) => res.data);
}
